import { fetch } from '@/plugin/axios/index.js'



/**
 * @param {Object} data
 * 获取单位列表
 */
export function getTotalStatistics() {
  return fetch ({
    url: '/repair/workbench/statistics/totalStatistics',
    method: 'GET',
  })
}


/**
 * @param {Object} data
 * 获取维保月历
 */
export function getMonthlyCalendar(data) {
  return fetch ({
    url: '/repair/workbench/statistics/monthlyCalendar',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取排行榜
 */
export function getUserRankingList(data) {
  return fetch ({
    url: '/repair/workbench/statistics/userRankingList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 获取电梯信息
 */
export function getLiftDetail(data) {
  return fetch ({
    url: '/repair/workbench/statistics/statisticsLiftInfoList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 获取维保超期
 */
export function getMaintainTodayOverdueList(data) {
  return fetch ({
    url: '/repair/workbench/statistics/maintainTodayOverdueList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 获取年检超期
 */
export function getInspectionTodayOverdueList(data) {
  return fetch ({
    url: '/repair/workbench/statistics/inspectionTodayOverdueList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取合同超期
 */
export function getFinancialOverdueList(data) {
  return fetch ({
    url: '/repair/workbench/statistics/financialOverdueList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取保险超期
 */
export function getInsuranceOverdueList(data) {
  return fetch ({
    url: '/repair/workbench/statistics/insuranceOverdueList',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/UserConsole/index.js